import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/esg/esgThree/esgThree.webp";

function EsgThree(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
            <div id="esgThree" className={`esgThree ${isVisible ? 'visible' : ''}`}>
                <div className="esgText">
                    <h1 className={`${isVisible ? 'visible' : ''}`}>{t("esg_three_title")} <span>{t("esg_three_title_span")}</span></h1>
                    <p className={`${isVisible ? 'visible' : ''}`}>
                        {t("esg_three_text")}
                    </p>
                </div>
                <div className={`esgImg ${isVisible ? 'visible' : ''}`}>
                    <img width={'800px'} src={img1} alt="" />
                </div>
            </div>
        </VisibilitySensor>
    )
}

export default EsgThree;